import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@material-ui/core';
import { ILinkRow } from './types';
import { getFormattedText } from '../utils/getFormattedText';
import { getLinkRoute } from '../utils/getLinkRoute';

export const LinkRow = ({ column, item, ...props }: ILinkRow) => {
    const { field, type, route } = column;

    const text = getFormattedText({ type, field, item, column });

    if (!route) return null;

    return (
        <Link
            color="inherit"
            component={RouterLink}
            to={getLinkRoute(route, field, text)}
            variant="h6"
            {...props}
        >
            {text}
        </Link>
    );
};
